
export const URL = "conference/create";
export const URL_INFO = "conference";
export const GET_INFO = "GET_HOME_INFO";
